import {useMemo, useState} from "react";
import {http, HttpParams} from "@firefly/fly-http";
import {useMutation, useQuery} from "react-query";
import TTLCounter from "src/util/TTLCounter";


export interface SendInput {

}
export interface VerifyNumberInput {
    number: string;
}
export interface VerifyOutput {
    token: string;
}
// export interface UseVerifyMobileType {
//     send: (input: SendInput) => Promise<void>;
//     isSendLoading: boolean,
//     isSendDisabled: boolean;
//     sendLabel: string;
//     isVerifyLoading: boolean;
//     verify: (input: VerifyInput) => Promise<VerifyOutput>;
// }

export default function useVerifyUserMobileNumber(userid: string | undefined) {
    const {
        mutateAsync: verify,
        isLoading: isVerifyLoading,
        error: verifyError,
    } = useMutation<VerifyOutput, any, VerifyNumberInput>( {
        mutationFn: (input: VerifyNumberInput) => {
            return http.post("/api/wangame/viewer/verify-user-mobile/verify-number", {
                userid: userid,
                number: input.number
            })
        },
        onSuccess: () => {
        },
    })

    return {
        verify,
        isVerifyLoading,
        verifyError,
    }

}
